import { render } from "./EnergeticTest.vue?vue&type=template&id=c5df3fc0"
import script from "./EnergeticTest.vue?vue&type=script&lang=js"
export * from "./EnergeticTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__